(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  var $slider = $('.reviews-slider');
  var $cards = $('.review-card');
  var cardsPerSlide = $(window).width() > 768 ? 2 : 1;
  var slideWidth = 100; // percentage width per slide
  var currentSlide = 0;

  // Clone slides for infinite effect
  $slider.append($cards.clone());
  var totalSlides = Math.ceil($slider.children().length / cardsPerSlide);

  // Create dots dynamically
  for (let i = 0; i < totalSlides / 2; i++) {
    $('.slider-dots').append('<span class="dot' + (i === 0 ? ' active' : '') + '"></span>');
  }

  var $dots = $('.dot');

  function goToSlide(index, animate = true) {
    var translateX = -(index * slideWidth);
    if (animate) {
      $slider.css({
        'transition': 'transform 0.5s ease',
        'transform': 'translateX(' + translateX + '%)'
      });
    } else {
      $slider.css({
        'transition': 'none',
        'transform': 'translateX(' + translateX + '%)'
      });
    }

    // update dots
    var activeDot = index % ($dots.length);
    $dots.removeClass('active');
    $dots.eq(activeDot).addClass('active');
  }

  function nextSlide() {
    currentSlide++;
    goToSlide(currentSlide);

    // When reaching cloned slides, reset to start (no flicker)
    if (currentSlide >= totalSlides - 1) {
      setTimeout(function () {
        currentSlide = 0;
        goToSlide(currentSlide, false);
      }, 600); // wait for animation to finish
    }
  }

  // Dot click
  $dots.on('click', function () {
    var index = $(this).index();
    currentSlide = index;
    goToSlide(currentSlide);
  });

  // Auto scroll
  var autoSlide = setInterval(nextSlide, 4000);

  // Pause on hover
  $('.reviews-section').hover(
    function () { clearInterval(autoSlide); },
    function () { autoSlide = setInterval(nextSlide, 4000); }
  );

  // Responsive recalculation
  $(window).on('resize', function () {
    cardsPerSlide = $(window).width() > 768 ? 2 : 1;
    goToSlide(0, false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.parentElement;
    const allItems = document.querySelectorAll('.faq-item');
    allItems.forEach(i => {
      if (i !== item) i.classList.remove('active');
    });
    item.classList.toggle('active');

    // Toggle icon
    const icon = button.querySelector('.faq-icon');
    if (item.classList.contains('active')) {
      icon.textContent = '–';
    } else {
      icon.textContent = '+';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-ingredients-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.ingredient-card');

  cards.forEach(card => {
    const button = card.querySelector('.toggle-info');
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      card.classList.toggle('active');
      cards.forEach(other => {
        if (other !== card) {
          other.classList.remove('active');
        }
      });
    });
  });
});








$(document).ready(function() {

  $('.view-nutrition').on('click', function() {
    const popup = $('#nutrition-popup');

    popup.fadeIn(200, function() {
      popup.css('display', 'flex'); // force flex after fadeIn
    });
  });

  $('.close-popup, #nutrition-popup').on('click', function(e) {
    if (e.target !== this) return;
    $('#nutrition-popup').fadeOut();
  });

});


  } catch(e) { console.error(e); }
})();
})();
